/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module core/constants/strings */
// UPPERCASE ACCENTED UNICODE RANGE: \u00C0-\u00DE
// LOWERCASE ACCENTED UNICODE RANGE: \u00DF-\u00FF
var STRINGS = {
  STD_ENCODING: 'utf8',
  STD_TAB_SPACE: "    "
};
export { STRINGS };